/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */
export const GENERIC_PROJECT_HORIZONTAL_NAV = 'GENERIC_PROJECT_HORIZONTAL_NAV' as const;

/**
 * @deprecated delete this constant when jira_nav4 is cleaned up.
 * Replace value with undefined where used in routes.
 */
export const GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV =
	'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV' as const;
